import { TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import Select from 'react-select';
import { api } from '../../apiConfig';

interface Props {
  errors: any;
  data: Record<string, any>;
  onChange?: (field: string, value: any) => void;
  onChangeChild?: (section: any, field: string, value: any) => void;
  isChild?: boolean
}
const DeliveryOptionsDropdown = (props: Props) => {
  const [deliveryOptions, setDeliveryOptions] = useState<
    { id: number; name: string }[]
  >([]);

  useEffect(() => {
    const fetchDeliveryOptions = async () => {
      try {
        const response = await api.get(`/api/customers/deliveryoptions`);
        setDeliveryOptions(response.data);
      } catch (error) {
        console.error('Error fetching delivery options', error);
      }
    };

    fetchDeliveryOptions();
  }, []);
  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      height: 54,
      minHeight: 54,
      borderColor: (props.isChild ? props.errors?.facilityDeliveryOption : props.errors?.shippingDeliveryOption)
        ? 'red'
        : provided.borderColor,
      boxShadow: (props.isChild ? props.errors?.facilityDeliveryOption : props.errors?.shippingDeliveryOption)
        ? '0 0 0 .5px red'
        : provided.boxShadow,
      '&:hover': {
        borderColor: (props.isChild ? props.errors?.facilityDeliveryOption : props.errors?.shippingDeliveryOption)
          ? 'red'
          : provided.borderColor,
      },
    }),
    menu: (provided: any) => ({
      ...provided,
      zIndex: 500,
    }),
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', marginTop: 16 }}>
      <Select
        options={deliveryOptions}
        placeholder='Delivery Instructions *'
        value={
          deliveryOptions.find(
            (option) => option.id === props.data.deliveryOption?.id
          ) || null
        }
        onChange={(e) => {
           props.onChangeChild ?
              props.onChangeChild('shippingInfo', 'deliveryOption', e)
            : props.onChange &&
              props.onChange('deliveryOption', {
                id: e?.id,
                name: e?.name,
              });
        }}
        getOptionLabel={(option) => option?.name}
        getOptionValue={(option) => String(option.id)}
        styles={customStyles}
      />

      {props.data.deliveryOption?.name === 'Other' && (
        <TextField
          label='Other Delivery Option'
          name='deliveryOptionOther'
          value={props.data.deliveryOptionOther}
          onChange={(e) =>
          props.onChangeChild ?
                props.onChangeChild(
                  'shippingInfo',
                  'deliveryOptionOther',
                  e.target.value
                )
              : props.onChange &&
                props.onChange('deliveryOptionOther', e.target.value)
          }
          fullWidth
          margin='normal'
          sx={{ backgroundColor: '#fff', marginBottom: 3 }}
        />
      )}
    </div>
  );
};

export default DeliveryOptionsDropdown;
